<template>
    <v-dialog v-model="dialog" width="1200" persistent content-class="dialog-sobre">
        <v-card style="overflow-x: scroll;">
            <v-list >
                <v-list-item style="display: flex; width: 100%; justify-content: end; padding: 20px 25px 0px 25px;" >
                    <v-list-item-title style="font-size: 18px; font-weight: bold;">Editar RID</v-list-item-title>
                    <v-btn 
                        @click="isEditing ? setIsEditing() : $emit('close')"
                        style="display: flex; background-color: transparent; justify-self: center; margin-right: 12px;"
                    >
                        {{ isEditing ? "Cancelar" : "Voltar"}}
                    </v-btn>
                    <v-btn 
                        @click="isEditing ? setIsEditing() : validateAndProceed()" 
                        style="display: flex; background-color: blue; align-self: end; justify-self: end; margin-bottom: 6px; color: white !important;"
                    >
                        {{ isEditing ? 'Salvar' : "Editar"}} <v-icon style="margin-left: 4px;">{{isEditing ? 'mdi-check' : "mdi-pencil"}}</v-icon>
                    </v-btn>
                </v-list-item>
            </v-list>

            <v-form ref="form" v-model="isFormValid">
                <v-tabs
                    v-model="tab"
                    align-with-title            
                    show-arrows
                    class="tabsBg"
                >
                    <v-tabs-slider color="blue"></v-tabs-slider>

                    <v-tab
                        v-for="item in items"
                        :key="item"
                    >
                        {{ item }}
                    </v-tab>

                    <!-- Geral -->
                    <v-tabs-items v-model="tab">
                        <v-tab-item>
                            <v-list style="display: flex; padding: 12px; flex-direction: row; flex-wrap: wrap; gap: 18px;">
                                <v-container>
                                    <v-radio-group v-model="payload.type" disabled>
                                        <v-row justify="space-between">
                                            <v-col cols="auto">
                                                <v-radio
                                                    label="Inspeção Parcial"
                                                    value="Parcial"
                                                ></v-radio>
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-radio
                                                    label="Inspeção Final"
                                                    value="Final"
                                                ></v-radio>
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-radio
                                                    label="Diligenciamento"
                                                    value="Diligenciamento"
                                                ></v-radio>
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-radio
                                                    label="Embarque"
                                                    value="Embarque"
                                                ></v-radio>
                                            </v-col>
                                        </v-row>
                                    </v-radio-group>
                                </v-container>

                                <v-autocomplete
                                    v-model="payload.purchaseOrderId"
                                    :items="pedidoDeCompraData"
                                    item-text="text"
                                    item-value="id"
                                    label="Pedido de Compra"
                                    dense
                                    disabled
                                    outlined
                                ></v-autocomplete>

                                <v-text-field label="Código" disabled v-model="payload.code" dense outlined></v-text-field>

                                <v-text-field label="Fornecedor" v-model="payload.supplierCorporateReason" disabled dense outlined></v-text-field>

                                <v-text-field label="Data" type="date" v-model="payload.date" disabled dense outlined></v-text-field>

                                <v-text-field label="JOB" type="text" v-model="payload.jobCode" disabled dense outlined></v-text-field>

                                <v-text-field label="Cliente" type="text" v-model="payload.client" disabled dense outlined></v-text-field>

                                <v-text-field label="Local"  v-model="payload.location" disabled dense outlined></v-text-field>

                                <v-text-field label="Contato" disabled v-model="payload.contact" dense outlined ></v-text-field>

                                <v-text-field label="Setor" disabled  v-model="payload.sector" dense outlined></v-text-field>

                                <v-text-field label="Telefone" disabled v-model="payload.phone" dense outlined 
                                v-mask="'(##) #####-####'"></v-text-field>

                                <v-text-field label="Técnico"  v-model="payload.technician" disabled dense outlined></v-text-field>

                                <v-text-field label="Coordenador"  v-model="payload.coordinator" disabled dense outlined></v-text-field>

                            </v-list>
                            <v-btn disabled @click="setModalOpen" style="display: flex; background-color: blue; align-self: end; justify-self: end; margin-bottom: 6px; color: white !important;">
                                Adicionar <v-icon style="margin-left: 4px;">mdi-plus</v-icon>
                            </v-btn>
                            <v-data-table
                                :headers="headers"
                                :items="payload.items"
                                class="elevation-1"
                                disable-sort
                                :single-expand="false"
                                >
                                <!-- Slot para a coluna "Aprovado" -->
                                <template slot="item.approve" slot-scope="{ item }">
                                    <v-checkbox
                                    v-model="item.approve"
                                    disabled
                                    color="success"
                                    hide-details
                                    dense
                                    ></v-checkbox>
                                </template>
                            </v-data-table>
                        </v-tab-item>

                        <!-- Status de Fabricação -->
                        <v-tab-item>
                            <v-container>
                                <v-data-table
                                :headers="headersManufaturingStatus"
                                :items="payload.items"
                                dense
                                fixed-header
                                mobile-breakpoint="0"
                                class="elevation-1"
                                >
                                <template v-slot:item="{ item, index }">
                                    <tr>
                                    <!-- <td>{{ item.ordemDeServico.codigo }}</td> -->
                                    <td>{{ item.quantidade }}</td>
                                    <td>{{ item.descricao }}</td>

                                    <!-- Campos editáveis a partir de "PESO" -->
                                    <td v-for="(key, i) in editableFieldsManufaturingStatus" :key="i" style="min-width: 150px;">
                                        <v-text-field
                                        v-model="payload.items[index][key]"
                                        disabled
                                        type="number"
                                        dense
                                        outlined
                                        class="mt-1"
                                        ></v-text-field>
                                    </td>
                                    </tr>
                                </template>
                                </v-data-table>
                            </v-container>
                        </v-tab-item>

                        <!-- Documentos de Referência -->
                        <v-tab-item>
                            <v-container>
                                <v-row>
                                    <v-col v-for="(doc, index) in payload.referenceDocuments" :key="index" cols="12" style="display: flex;">
                                        <!-- <v-btn disabled icon @click="handleClick(index)">
                                            <v-icon>{{ index === 0 ? 'mdi-plus' : 'mdi-minus' }}</v-icon>
                                        </v-btn> -->
                                        <v-text-field
                                            v-model="payload.referenceDocuments[index]"
                                            :label="`Documento ${index + 1}`"
                                            disabled
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-tab-item>

                        <v-tab-item>
                            <v-container>
                                <v-row>
                                    <v-col v-for="(item, index) in checklist" :key="index" cols="12" sm="6" md="4">
                                        <v-container class="d-flex align-center">
                                            <!-- Checkbox -->
                                            <v-checkbox
                                                v-model="payload.inspectionScope"
                                                :label="item.label"
                                                disabled
                                                :value="item.value"
                                                dense
                                                class="checkbox-label"
                                            ></v-checkbox>

                                            <!-- Campo de texto ao lado da checkbox -->
                                            <v-text-field
                                                v-if="index === checklist.length - 1"
                                                v-model="item.label"
                                                disabled
                                                @blur="updateInspectionScope(item)"
                                                label=""
                                                dense
                                                class="ml-2"
                                            ></v-text-field>
                                        </v-container>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-tab-item>

                        <!-- Detalhes da Inspeção -->
                        <v-tab-item>
                            <v-container>
                                <v-row>
                                    <v-col
                                        v-for="(value, key, index) in payload.inspectionDetails"
                                        :key="index"
                                        cols="12"
                                    >
                                        <v-textarea
                                            v-model="payload.inspectionDetails[key]" 
                                            :label="key" 
                                            disabled
                                            outlined
                                            dense
                                            rows="2"
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-tab-item>

                        <!-- Resultados -->
                        <v-tab-item>
                            <v-container>
                                <v-row>
                                    <v-col
                                        v-for="(value, key, index) in payload.results"
                                        :key="index"
                                        cols="12"
                                    >
                                        <v-text-field
                                            v-model="payload.results[key]"
                                            :label="`${key}`"
                                            disabled
                                            outlined
                                            dense
                                            rows="2"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-tab-item>

                        <!-- Registros de Ocorrências -->
                        <v-tab-item>
                            <v-container>
                                <v-textarea
                                    v-model="payload.ocurrenceRecord"
                                    :label="`Registro de Ocorrências`"
                                    disabled
                                    outlined
                                    dense
                                    rows="3"
                                ></v-textarea>
                            </v-container>
                        </v-tab-item>

                       <!-- Evidências Fotográficas -->
                       <v-tab-item>
                            <v-container>
                                <v-file-input
                                    accept="image/*"
                                    label="Selecionar Imagens"
                                    prepend-icon="mdi-camera"
                                    @change="onFileChange"
                                    :disabled="images.length >= 24 || !isEditing"
                                />

                                <!-- Lista de imagens adicionadas -->
                                <v-row>
                                    <v-col v-for="(image, index) in images" :key="index" cols="12" md="3">
                                        <v-card class="pa-3">
                                            <v-img :src="image.image.base64 ? image.image.base64 : image.image.original" width="245" height="245"></v-img>

                                            <!-- Campo de descrição -->
                                            <p class="mt-2 mb-2">{{ image.description }}</p>

                                            <!-- Botão para remover a imagem -->
                                            <v-btn disabled color="red" dark small @click="removeImage(index)">
                                                <v-icon>mdi-delete</v-icon> Remover
                                            </v-btn>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-tab-item>
                    </v-tabs-items>
                </v-tabs>
            </v-form>
        </v-card>
        <ResizeAndCropImageView v-model="isResizeAndCropModalOpen" @close="isResizeAndCropModalOpen=false" :image="image" @image-updated="updateImage" :ids="imageIds" @ids="updateImageIds"/>
        <SelectOsItemModal :value="modalOpen" @close="modalOpen=false" :items="osItems" :osItens.sync="payload.items" :pedidoDeCompra="payload.purchaseOrderId"/>
    </v-dialog>
</template>

<script>
import Vue from 'vue';
import SelectOsItemModal from "./RIDSelectOsItemModalView.vue"
import ResizeAndCropImageView from './RIDResizeAndCropImageView.vue';
import { timestamp } from '@vueuse/core/index.cjs';
export default {
    props: {
        value: Boolean, // Permite o controle externo do modal
        id: String,
        refreshRID: Function
    },
    components: {
        SelectOsItemModal,
        ResizeAndCropImageView
    },
    data() {
        return {
            fornecedorData: [],
            osItems: [],
            pedidoDeCompraData: [],
            jobData: [],
            step: 1,
            imageIds: [],
            tab: null,
            items: [
                'Geral', 'Status de Fabricação', 'Documentos de Referência', 'Escopo da Inspeção', 'Detalhes da Inspeção', 'Resultados', 'Registros de Ocorrências', 'Evidências Fotográficas'
            ],
            e1: 1,
            isFormValid: false,
            isTypeValid: true,
            isEditing: false,
            clientData: [],
            modalOpen: false,
            isResizeAndCropModalOpen: false,
            search: '',
            image: {},
            images: [],
            detailValues: {},
            resultsValues: {},
            rules: {
                required: v => !!v || "Campo obrigatório", // Regra de validação
            },
            payload: this.getInitialPayload(),
            headers: [
                { text: "Item", value: "itemCodigo", width: '100px' },
                { text: "Descrição", value: "descricao", width: '150px' },
                // { text: "N° PC", value: "pedidoDeCompraCodigo", width: '100px' },
                // { text: "Prazo PC", value: "prazoPedidoDeCompra", width: '100px' },
                // { text: "OS", value: "job", width: '180px' },
                { text: "Quant.", value: "quantidade", width: '100px' },
                { text: "Aprovação", value: "approve", width: '100px' }
            ],
            headersManufaturingStatus: [
                // { text: "OS", value: "ordemDeServico.codigo", width: "100px" },
                { text: "QTD", value: "quantidade", width: "100px" },
                { text: "DESCRIÇÃO", value: "descricao", width: "200px" },
                { text: "PESO", value: "peso", width: "200px" },
                { text: "MP", value: "mp", width: "200px" },
                { text: "PREP.", value: "prep", width: "200px" },
                { text: "MONT.", value: "mont", width: "200px" },
                { text: "SOLD.", value: "sold", width: "200px" },
                { text: "PINTURA", value: "pintura", width: "200px" },
                { text: "INSPEÇÃO", value: "inspecao", width: "200px" }
            ],
            editableFieldsManufaturingStatus: ["peso", "mp", "prep", "mont", "sold", "pintura", "inspecao"],
            selectedItems: [],
            checklist: [
                { label: "Identificação de Matéria Prima", value: "Identificação de Matéria Prima" },
                { label: "Análise de Certificados", value: "Análise de Certificados" },
                { label: "Inspeção Visual de Soldagem", value: "Inspeção Visual de Soldagem" },
                { label: "Inspeção Dimensional", value: "Inspeção Dimensional" },
                { label: "Testemunho de END", value: "Testemunho de END" },
                { label: "Inspeção de Montagem Final", value: "Inspeção de Montagem Final" },
                { label: "Teste Hidrostático", value: "Teste Hidrostático" },
                { label: "Teste de Estanqueidade", value: "Teste de Estanqueidade" },
                { label: "Teste Pneumático", value: "Teste Pneumático" },
                { label: "Inspeção Visual Revestimento", value: "Inspeção Visual Revestimento" },
                { label: "Teste Holiday Detector", value: "Teste Holiday Detector" },
                { label: "Cor / Tonalidade", value: "Cor / Tonalidade" },
                { label: "Medição Espessura Revestimento", value: "Medição Espessura Revestimento" },
                { label: "Teste de Aderência", value: "Teste de Aderência" },
                { label: "Teste de Performance", value: "Teste de Performance" },
                { label: "Ensaio de Rotina", value: "Ensaio de Rotina" },
                { label: "Ensaio de Tipo", value: "Ensaio de Tipo" },
                { label: "Teste Operação/Funcionamento", value: "Teste Operação/Funcionamento" },
                { label: "Teste de Nível Ruído/ Vibração", value: "Teste de Nível Ruído/ Vibração" },
                { label: "Medição de Temperatura", value: "Medição de Temperatura" },
                { label: "Teste Resistência Isolamento", value: "Teste Resistência Isolamento" },
                { label: "Teste de Tensão Induzida", value: "Teste de Tensão Induzida" },
                { label: "Teste de Continuidade Elétrica", value: "Teste de Continuidade Elétrica" },
                { label: "Medição Corrente Consumida", value: "Medição Corrente Consumida" },
                { label: "Medição Resistência Ôhmica", value: "Medição Resistência Ôhmica" },
                { label: "Teste de Resistividade", value: "Teste de Resistividade" },
                { label: "Teste de Condutibilidade", value: "Teste de Condutibilidade" },
                { label: "Inspeção Embalagem e Marcação", value: "Inspeção Embalagem e Marcação" },
                { label: "Ensaio de Tração (Pull Off)", value: "Ensaio de Tração (Pull Off)" },
                { label: "", value: "" }
            ]
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val); // Emite evento para atualizar o estado do modal
            }
        },
        themeClass() {
            return this.$vuetify.theme.dark ? 'dark-theme' : 'light-theme';
        },
    },
    methods: {

        setIsEditing() {
            this.isEditing = !this.isEditing;
        },

        updateImage({ croppedImage }) {
            this.image.image.base64 = croppedImage;
        },

        updateImageIds({ id }) {
            this.imageIds.push(id);
        },

        updateInspectionScope(item) {
            // Atualiza o payload.inspectionScope com o valor do item
            const index = this.payload.inspectionScope.indexOf(item.value);
            if (index === -1) {
                // Se o valor não estiver no array, adiciona
                this.payload.inspectionScope.push(item.value);
            } else {
                // Se o valor já estiver no array, atualiza
                this.payload.inspectionScope.splice(index, 1, item.value);
            }
        },
        
        async getRIDById() {
            let req = await Vue.prototype.$http.get(`/Entity/RID/search-fields`, { 
                params: { page: this.currentPage, limit: this.itemsPerPage, ids: this.id } 
            });

            let data = req.data.data.data[0];

            // console.log(data)

            // Garantir que os campos sejam objetos JSON válidos
            if (typeof data.referenceDocuments === "string") {
                data.referenceDocuments = JSON.parse(data.referenceDocuments);
            }

            if (typeof data.inspectionDetails === "string") {
                data.inspectionDetails = JSON.parse(data.inspectionDetails);
            }

            if (typeof data.results === "string") {
                // console.log(JSON.parse(data.inspectionDetails))
                data.results = JSON.parse(data.results);
                console.log(data.results)
            }

            if (data.inspectionScope.includes(';')) {
                data.inspectionScope = data.inspectionScope.split(';');
                console.log(data.inspectionScope)
                const scopeValue = data.inspectionScope; // Supondo que data.inspectionScope seja o valor a ser verificado

                scopeValue.forEach(value => {
                    // Verifique se o item não existe no checklist
                    const existsInChecklist = this.checklist.some(item => item.value === value);

                    // Se o item não existe no checklist, chama a função para atualizar
                    if (!existsInChecklist) {
                        // Aqui, você pode escolher qual item do checklist você quer atualizar
                        const lastItem = this.checklist[this.checklist.length - 1]; // Ou qualquer outro item
                        this.updateInspectionScope(lastItem);
                    }
                });
            }

            if (data.imagens_id != null) {
                let response = await Vue.prototype.$http.get(`/Entity/RID/search-items`, {
                    params: {
                        relationSchema: 'RIDImagens',
                        id: this.id,
                        page: 1,
                        limit: 200,
                        sortField: 'createAt',
                        sortDesc: 'false'
                    }
                });

                this.images = response.data.data.data.map(imagem => ({
                    ...imagem,
                    image: { base64: imagem.image[0] }
                }));

                this.imageIds = data.imagens_id;
            }

            
            this.payload = data;

            if (data.items != null) {
                let res = await Vue.prototype.$http.get(`/Entity/RID/search-items`, {
                    params: {
                        relationSchema: 'RIDOsItens',
                        id: this.id,
                        page: 1,
                        limit: 200,
                        sortField: 'createAt',
                        sortDesc: 'false'
                    }
                });

                this.payload.items = res.data.data.data;

                this.payload.items = await Promise.all(
                    this.payload.items.map(async (item) => {
                        let response = await Vue.prototype.$http.get(`/Entity/OrdemDeServicoItens/search-fields`, {
                            params: {
                                ids: item.osItemId,
                                page: 1,
                                limit: 1,
                            }
                        });

                        const { id, ...osItemWithoutId } = response.data.data.data[0];

                        // console.log('osItem', osItemWithoutId);

                        return {
                            ...item,
                            ...osItemWithoutId
                        };
                    })
                );
                console.log('Itens processados:', this.payload.items);
            }

            // console.log(this.payload);
        },

        getInitialPayload() {
            this.tab = "Geral"
            return {
                purchaseOrderId: '',
                code: '',
                type: '',
                supplierId: '',
                supplierCorporateReason: '',
                date: '',
                jobId: '',
                jobCode: '',
                client: '',
                location: '',
                contact: '',
                contactSignature: '',
                sector: '',
                phone: '',
                technician: '',
                technicianSignature: '',
                coordinator: '',
                items: [],
                referenceDocuments: [""],
                inspectionScope: [],
                inspectionDetails: {},
                results: {},
                ocurrenceRecord: '',
                // attachments: []
            }
        },

        openResizeModal(image) {
            this.isResizeAndCropModalOpen = true;
            this.image = image;
        },

        async validateAndProceed() {
            this.isTypeValid = this.payload.type.length >= 0; // Verifica se pelo menos um checkbox foi marcado

            if (this.$refs.form.validate() && this.isTypeValid) {

                const ids = [];

                // Criar Imagens de RID
                // const promisesImages = this.images.map(async image => {
                //     if (image.id) {
                //         const response = await Vue.prototype.$http.post('/Entity/RIDImagens', {
                //             image: [image.image],
                //             description: image.description
                //         });
                //         return response.data.data.id; // Retorna o ID
                //     } else {}
                // });

                // const resolvedIdsImages = await Promise.all(promisesImages);

                // Criar itens de OS de RID
                // const promisesOsItem = this.payload.items.map(async item => {
                //     if (item.id) {
                //         return item.id
                //     } else {
                //         const response = await Vue.prototype.$http.post('/Entity/RIDOsItens', {
                //             osItemId: item.id,
                //             approve: item.approve ? item.approve : false,
                //             peso: item.peso,
                //             mp: item.mp,
                //             prep: item.prep,
                //             mont: item.mont,
                //             sold: item.sold,
                //             pintura: item.pintura,
                //             inspecao: item.inspecao
                //         });
                //         return response.data.data.id; // Retorna o ID
                //     }

                // });

                // const resolvedIdsOsItem = await Promise.all(promisesOsItem);

                // ids.push(...resolvedIds); 
                await Vue.prototype.$http.put('/Entity/RID', {
                    ...this.payload,
                    referenceDocuments: JSON.stringify(this.payload.referenceDocuments),
                    inspectionScope: this.payload.inspectionScope.join(';'),
                    inspectionDetails: JSON.stringify(this.payload.inspectionDetails),
                    results: JSON.stringify(this.payload.results),
                    imagens_id: this.imageIds
                });
                // console.log('ids',ids)

                this.resetPayload(); // Limpa os dados

                this.refreshRID();

                this.$emit("close"); // Fecha o modal

            } else {
                console.log("Formulário inválido!");
            }
        },

        resetPayload() {
            this.payload = this.getInitialPayload();
            this.isTypeValid = false;
            this.images = [];
        },

        onFileChange(file) {
            if (this.images.length >= 24) {
                return; // Impede a adição de novas imagens se já houver 24
            }

            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (e) => {
                this.images.push({
                    image: {
                        original: e.target.result,  // URL base64 da imagem
                        fileName: file.name       // Nome do arquivo
                    },
                    description: ""  // Descrição vazia
                });
                
                this.openResizeModal(this.images[this.images.length - 1])
            };

            console.log(this.images)
        },

        removeImage(index) {
        this.images.splice(index, 1);
        },

        setModalOpen() {
            this.modalOpen = !this.modalOpen;
        },

        // GET de todos pedidos de compra para autocomplete
        async getAllPurchaseOrder() {
            try {

                this.payload.supplier = this.search;
                let req = await Vue.prototype.$http.get(`/Entity/PedidoDeCompra/search-fields`, {
                    params: { 
                        searchFields: "codigo",
                        value: this.payload.pc,
                        page: 1,
                        limit: 30
                    }
                });
                console.log('REQUEST', req);
                
                this.pedidoDeCompraData = [...new Set(req.data.data.data.map(item => ({text: item.codigo, id: item.id})))];
            } catch (error) {
                console.error("Erro ao buscar fornecedores:", error);
                this.fornecedorData = []; // Evita que a variável fique indefinida
            }
        },

        async getPurchaseOrderById() {
            try {

                // let requestData = {
                //     viewName: "rid-pedido-de-compra-itens",
                //     params: [
                //         {
                //             name: "id",
                //             dataType: "String",
                //             value: this.payload.pc
                //         },
                //     ],
                //     page: 1,
                //     limit: 100
                // };

                const requestData = {
                    params: [
                    {
                        name: "id",
                        dataType: "String",
                        value: this.payload.purchaseOrderId
                    },
                    ],
                    viewName: "rid-pedido-de-compra-itens",
                    page: 1,
                    limit: 5
                };

                    // Make the request based on the graph type
                let response = await Vue.prototype.$http.post('/View/run', requestData);
                const data = response.data.data.data[0];
                this.payload.client = data.comprador.nome;
                this.payload.supplier = data.fornecedor.nome;
                this.payload.job = data.itens[0].osItems.ordemDeServico.job.codigo;

                this.osItems = data.itens.map(item => item.osItems);

            } catch (error) {
                console.error("Erro ao buscar fornecedores:", error);
                this.fornecedorData = []; // Evita que a variável fique indefinida
            }
        }
    },
    watch: {
        "payload.purchaseOrderId": {
            handler: "getPurchaseOrderById",
            immediate: true // Executa o watch imediatamente ao montar o componente
        },    
        id: {
        handler(newId) {
            this.getRIDById(newId);
            this.payload = this.getInitialPayload(); // Reseta payload sempre que o id mudar
        },
        immediate: true
        }
    },
    created() {
        this.getAllPurchaseOrder();
    }
};
</script>
  
<style scoped>

    .style-i {
        color: white;
        font-size: 22px;
    }
    /*
    .style-i:hover {
        color: white;
    }*/

    .item-content {
        border-bottom: 1px solid rgba(172, 168, 168, 0.719);
    }

    a {
        color: black;
        margin-left: 5px;
        color: black;
    }


    span {
        float: right;
        font-size: 10px;
    }
    .card-item{
        position: relative;
    }

    .card-item:hover {
        cursor: pointer;
        background-color: whitesmoke;
    }

    .btn-aprovar, .btn-enviar-obs {
        background-color: green;
        border-radius: 15px;
        padding: 6px;
        color: white;
        font-size: 12px;
        margin: 0px 8px;
    }

    .btn-aprovar:hover, .btn-enviar-obs:hover {
        background-color: white;
        border: 1px solid green;
        color: green;
    }

    .btn-reprovar, .btn-cancelar-obs {
        background-color: red;
        border-radius: 15px;
        padding: 6px;
        color: white;
        font-size: 12px;
        margin: 0px 8px;
    }

    .btn-reprovar:hover, .btn-cancelar-obs:hover {
        background-color: white;
        border: 1px solid red;
        color: red;
    }

    .obs-container {
        margin-top: 3px;
        border: 1px solid #c5c0c0;
        padding: 5px;
    }

    .span-enviado {
        position: absolute;
        right: 15px;
        bottom: 2px;
    }

    .v-list-item__content{
        padding: 0px;
        max-height: 75px;
    }

  .img {
    margin: auto;
  }
  
  .card {
    margin-left: 500px;
  }
  
  .v-btn {
    margin-top: 15px;
  }
  
  .dialog-sobre {
    width: 500px !important;
  }
  
  .v-dialog__content {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    pointer-events: none;
    position: fixed;
    top: 0;
    transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1), z-index 1ms;
    width: 100%;
    z-index: 6;
    outline: none;
  }

  .checkbox {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  
  .v-text-field--outlined fieldset {
    border: 0;
    border-bottom: 1px solid black;
    border-radius: 0;;
  }

  .v-text-field--outlined .v-text-field__slot {
    align-items: end !important;
  }

  .v-text-field .v-input__slot {
    padding: 0 !important;
  }

  .filterInputDate {
    outline: none;
    border: 1px solid #666;
    border-radius: 4px;
    width: 269px;
    padding-left: 10px;
    font-size: 12px;
    height: 40px;
  }

  .filterInput {
    width: 30%;
    text-decoration: none !important;
    border: none !important;
  }

  .theme--dark.v-list {
    background-color: #1e1e1e;
  }

  .v-sheet.v-stepper {
    border-radius: 0px;
  }

  .theme--dark.v-card {
    background-color: #1e1e1e;
  }

  .v-data-table-header {
    border-radius: 12px;
  }

  .v-btn[data-v-4b1b6f7c] {
    margin-top: 0px;
  }
  
  .v-stepper__header {
    box-shadow: none !important;
  }

  .v-stepper__content {
    padding: 0px 24px 16px 24px;
  }

  .theme--dark.tabsBg{
    background-color: #1e1e1e !important;
  }

  .checkbox-label ::v-deep(.v-label) {
    font-size: 16px; /* Aumente o tamanho conforme necessário */
    /* font-weight: bold; Opcional: deixa a fonte mais destacada */
    }
</style>
  